import {useQueryClient} from '@tanstack/react-query';
import {useApiMutation} from './api';
import {CreateMarket, PostMarket} from '../../shared/api/definitions/root';
import {ModelTestListResultKeys, ModelTestResultsKeys} from './scoringModel';
import {MetadataQueryKey} from '../../context/MetadataContext';
import {ScoringInfoQueryKey} from './scoringInfo';

export const MarketQueryKeys = {
  all: ['markets'],
} as const;

export const usePublishMarket = () => {
  const queryClient = useQueryClient();

  return useApiMutation(PostMarket, {
    onSuccess: async (
      _updatedMarket,
      {marketId, scoringModel, triggerRefresh}
    ) => {
      const keysToInvalidate = [
        // Refetch the list of markets
        [MetadataQueryKey],
        // Invalidate model test results
        ...(scoringModel
          ? [
              ModelTestListResultKeys.market(marketId),
              ModelTestResultsKeys.market(marketId),
            ]
          : []),
        ...(triggerRefresh ? [[ScoringInfoQueryKey]] : []),
      ];

      await Promise.all(
        keysToInvalidate.map((queryKey) =>
          queryClient.invalidateQueries({
            queryKey,
          })
        )
      );
    },
  });
};

export const useCreateMarket = () => {
  const queryClient = useQueryClient();

  return useApiMutation(CreateMarket, {
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};
